import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { ac as KeydownManager, a8 as KeydownAction, Z as doWhenDefaultIsNotPrevented, b as generateElementId, g as getDocument, J as isElementReady } from './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { d as defineCustomElement$1 } from './p-106f8152.js';
const tooltipCss = "@-webkit-keyframes tooltip-animation-enter{0%{opacity:0}100%{opacity:1;visibility:visible}}@keyframes tooltip-animation-enter{0%{opacity:0}100%{opacity:1;visibility:visible}}@-webkit-keyframes tooltip-animation-leave{0%{opacity:1;visibility:visible}99%{opacity:0}100%{opacity:0;visibility:hidden}}@keyframes tooltip-animation-leave{0%{opacity:1;visibility:visible}99%{opacity:0}100%{opacity:0;visibility:hidden}}.sc-owc-tooltip-h{--tooltip-enter-delay:0;--tooltip-leave-delay:0;--tooltip-enter-duration:200ms;--tooltip-leave-duration:200ms;display:contents;position:absolute;border-radius:var(--one-spacing-radius-5-xs);white-space:normal;z-index:var(--one-z-index-tooltip);font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-caption-font-size);line-height:var(--one-typography-desktop-caption-line-height);-webkit-font-kerning:var(--one-typography-desktop-caption-font-kerning);font-kerning:var(--one-typography-desktop-caption-font-kerning);font-weight:var(--one-text-font-weight-regular)}.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip{font-family:var(--one-typography-font-family);font-size:inherit !important;line-height:inherit !important;-webkit-font-kerning:inherit !important;font-kerning:inherit !important;font-weight:inherit !important;min-width:inherit;max-width:inherit;width:inherit;-webkit-box-shadow:none;box-shadow:none;z-index:inherit;color:inherit;background-color:inherit;border-radius:inherit;border:inherit}.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip>div.sc-owc-tooltip{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip .owc-tooltip__title.sc-owc-tooltip{font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-body-2-font-size);line-height:var(--one-typography-desktop-body-2-line-height);-webkit-font-kerning:var(--one-typography-desktop-body-2-font-kerning);font-kerning:var(--one-typography-desktop-body-2-font-kerning);font-weight:var(--one-text-font-weight-regular)}.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip .owc-tooltip__body.sc-owc-tooltip{overflow-wrap:break-word}.sc-owc-tooltip-h:not(.owc-tooltip--animation):not(.owc-tooltip--visible) owc-popover.owc-tooltip__popover.sc-owc-tooltip{opacity:0;visibility:hidden}.sc-owc-tooltip-h:not(.owc-tooltip--animation).owc-tooltip--visible owc-popover.owc-tooltip__popover.sc-owc-tooltip{opacity:1}.owc-tooltip--animation.sc-owc-tooltip-h:not(.owc-tooltip--visible).owc-tooltip--animated owc-popover.owc-tooltip__popover.sc-owc-tooltip{-webkit-animation-name:tooltip-animation-leave;animation-name:tooltip-animation-leave;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-duration:var(--tooltip-leave-duration);animation-duration:var(--tooltip-leave-duration);-webkit-animation-delay:var(--tooltip-leave-delay);animation-delay:var(--tooltip-leave-delay);visibility:visible}.owc-tooltip--animation.sc-owc-tooltip-h:not(.owc-tooltip--visible):not(.owc-tooltip--animated) owc-popover.owc-tooltip__popover.sc-owc-tooltip{visibility:hidden}.owc-tooltip--animation.owc-tooltip--visible.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip{-webkit-animation-name:tooltip-animation-enter;animation-name:tooltip-animation-enter;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-duration:var(--tooltip-enter-duration);animation-duration:var(--tooltip-enter-duration);-webkit-animation-delay:var(--tooltip-enter-delay);animation-delay:var(--tooltip-enter-delay);visibility:hidden}.owc-tooltip--variant-primary.sc-owc-tooltip-h{color:var(--one-color-foreground-intensity-lowest);background-color:var(--one-color-background-intensity-high)}.owc-tooltip--variant-secondary.sc-owc-tooltip-h{color:var(--one-color-foreground-base);background-color:var(--one-color-background-base)}.owc-tooltip--size-medium.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip{padding:var(--one-spacing-padding-4-xs)}.owc-tooltip--size-small.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip{padding:var(--one-spacing-gap-5-xs) var(--one-spacing-gap-4-xs)}@media (forced-colors: active){.owc-tooltip--variant-secondary.sc-owc-tooltip-h owc-popover.owc-tooltip__popover.sc-owc-tooltip{outline:none}}";
const OwcTooltipStyle0 = tooltipCss;
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const showEvents = ['mouseenter', 'focusin'];
const hideEvents = ['mouseleave', 'focusout'];
const DEFAULT_MAX_OFFSET = 8;
const DEFAULT_DURATION = 200;
const Tooltip = /*@__PURE__*/proxyCustomElement(class Tooltip extends H {
  constructor() {
    super();
    this.__registerHost();
    this.visibleChange = createEvent(this, "visibleChange", 3);
    this.clickOutside = createEvent(this, "clickOutside", 3);
    this.component = new ComponentUtils(this);
    this.popoverRef = useRef();
    this.enterAnimationHandler = e => {
      if (e.animationName === 'tooltip-animation-enter' && e.currentTarget === this.hostElement) {
        this.enterAnimationStarted = true;
      }
    };
    this.leaveAnimationHandler = e => {
      if (e.animationName === 'tooltip-animation-leave' && e.currentTarget === this.hostElement) {
        this.enterAnimationStarted = false;
      }
    };
    this.show = () => this.visible = true;
    this.hide = () => this.visible = false;
    this.onAnchorKeydown = e => {
      KeydownManager.isKeyMatching(e, KeydownManager.DefaultKeys[KeydownAction.CLOSE]) && this.hide();
    };
    this.onPopoverVisibleChange = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.visible = ev.detail);
    };
    this.onPopoverClickOutside = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.clickOutside.emit());
    };
    this.hostId = generateElementId(this.hostElement);
    this.anchor = undefined;
    this.placement = 'bottom';
    this.strategy = 'fixed';
    this.variant = 'primary';
    this.size = 'medium';
    this.visible = false;
    this.disableTriggers = false;
    this.enterDelay = 0;
    this.leaveDelay = 0;
    this.enterDuration = DEFAULT_DURATION;
    this.leaveDuration = DEFAULT_DURATION;
    this.offset = [0, DEFAULT_MAX_OFFSET];
    this.popoverProps = undefined;
    this.animation = false;
    this.enterAnimationStarted = false;
  }
  /** Updates popover position to reflect untracked changes on anchor element */
  forceUpdate() {
    var _a;
    return (_a = this.popoverRef.current) === null || _a === void 0 ? void 0 : _a.forceUpdate();
  }
  handleDelay() {
    this.hostElement.style.setProperty('--tooltip-enter-delay', `${this.enterDelay || 0}ms`);
    this.hostElement.style.setProperty('--tooltip-leave-delay', `${this.leaveDelay || 0}ms`);
    this.hostElement.style.setProperty('--tooltip-enter-duration', `${this.enterDuration || 0}ms`);
    this.hostElement.style.setProperty('--tooltip-leave-duration', `${this.leaveDuration || 0}ms`);
  }
  onVisibleChange(newValue, oldValue) {
    var _a;
    !!newValue !== !!oldValue && this.visibleChange.emit(!!newValue);
    this.animation = true;
    this.visible && ((_a = this.popoverRef.current) === null || _a === void 0 ? void 0 : _a.forceUpdate());
  }
  onAnchorChanged() {
    this.detachEvents().attachEvents();
  }
  onDisableTriggersChanged() {
    this.detachEvents().attachEvents();
  }
  componentDidLoad() {
    this.handleDelay();
  }
  connectedCallback() {
    this.detachEvents().attachEvents();
  }
  disconnectedCallback() {
    this.detachEvents();
  }
  getAnchorElement() {
    var _a;
    return typeof this.anchor === 'string' ? (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.getElementById(this.anchor) : this.anchor;
  }
  getAnchorElementId() {
    const anchor = this.getAnchorElement();
    if (anchor) {
      !anchor.id && (anchor.id = generateElementId(anchor));
      return anchor.id;
    }
  }
  attachEvents() {
    isElementReady(() => !!this.getAnchorElement()).then(() => {
      const anchor = this.getAnchorElement();
      if (anchor && !this.disableTriggers) {
        showEvents.forEach(event => anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener(event, this.show));
        hideEvents.forEach(event => anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener(event, this.hide));
        anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener('keydown', this.onAnchorKeydown);
      }
    });
    return this;
  }
  detachEvents() {
    const anchor = this.getAnchorElement();
    if (anchor) {
      showEvents.forEach(event => anchor === null || anchor === void 0 ? void 0 : anchor.removeEventListener(event, this.show));
      hideEvents.forEach(event => anchor === null || anchor === void 0 ? void 0 : anchor.removeEventListener(event, this.hide));
      anchor === null || anchor === void 0 ? void 0 : anchor.removeEventListener('keydown', this.onAnchorKeydown);
    }
    return this;
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`variant-${this.variant || 'primary'}`]: true,
      [`size-${this.size || 'medium'}`]: true,
      visible: this.visible,
      animation: this.animation,
      animated: this.enterAnimationStarted
    });
    const popoverClasses = this.component.getChildBemClasses('popover', hostClasses);
    const titleClasses = this.component.getChildBemClasses('title', hostClasses);
    const bodyClasses = this.component.getChildBemClasses('body', hostClasses);
    const _a = this.popoverProps || {},
      {
        ref: originalPopoverRef,
        onVisibleChange: originalPopoverVisibleChange,
        onClickOutside: originalPopoverClickOutside
      } = _a,
      popoverProps = __rest(_a, ["ref", "onVisibleChange", "onClickOutside"]);
    return h(Host, Object.assign({
      key: '0ce1b3526b3789ec1ac892860b689131b311063c',
      tabIndex: -1,
      class: hostClasses
    }, accessibility({
      role: 'tooltip',
      aria: {
        labelledby: this.getAnchorElementId()
      }
    }), {
      onAnimationStart: this.enterAnimationHandler,
      onAnimationEnd: this.leaveAnimationHandler
    }), h("owc-popover", Object.assign({
      key: '0aa219bd28c65507e55362441e06937a2366f985',
      ref: el => this.popoverRef(el, [originalPopoverRef]),
      class: popoverClasses,
      anchor: this.anchor,
      visible: true,
      strategy: this.strategy,
      offset: this.offset,
      tabIndex: -1,
      position: this.placement,
      trigger: "manual",
      disableAccessibility: true
    }, popoverProps, {
      onVisibleChange: e => this.onPopoverVisibleChange(e, originalPopoverVisibleChange),
      onClickOutside: e => this.onPopoverClickOutside(e, originalPopoverClickOutside)
    }), h("div", {
      key: '085c7038022522f0d94af3965a3ec44a59b78c93',
      class: titleClasses
    }, h("slot", {
      key: 'f520c2c560cb5989142d3e534684965b6766ad28',
      name: "title"
    })), h("div", {
      key: 'd352793612e797e4fbc33e7603253f70e8495ab4',
      class: bodyClasses
    }, h("slot", {
      key: '7b4fc9d74ef8c625bad992c9a5c3dee8c1e1d3fb'
    }))));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "enterDelay": ["handleDelay"],
      "leaveDelay": ["handleDelay"],
      "enterDuration": ["handleDelay"],
      "leaveDuration": ["handleDelay"],
      "visible": ["onVisibleChange"],
      "anchor": ["onAnchorChanged"],
      "disableTriggers": ["onDisableTriggersChanged"]
    };
  }
  static get style() {
    return OwcTooltipStyle0;
  }
}, [6, "owc-tooltip", {
  "hostId": [1537, "id"],
  "anchor": [1],
  "placement": [513],
  "strategy": [513],
  "variant": [513],
  "size": [513],
  "visible": [1540],
  "disableTriggers": [516, "disable-triggers"],
  "enterDelay": [514, "enter-delay"],
  "leaveDelay": [514, "leave-delay"],
  "enterDuration": [514, "enter-duration"],
  "leaveDuration": [514, "leave-duration"],
  "offset": [16],
  "popoverProps": [16],
  "animation": [32],
  "enterAnimationStarted": [32],
  "forceUpdate": [64]
}, undefined, {
  "enterDelay": ["handleDelay"],
  "leaveDelay": ["handleDelay"],
  "enterDuration": ["handleDelay"],
  "leaveDuration": ["handleDelay"],
  "visible": ["onVisibleChange"],
  "anchor": ["onAnchorChanged"],
  "disableTriggers": ["onDisableTriggersChanged"]
}]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-tooltip", "owc-popover"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-tooltip":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Tooltip);
        }
        break;
      case "owc-popover":
        if (!customElements.get(tagName)) {
          defineCustomElement$1();
        }
        break;
    }
  });
}
export { Tooltip as T, defineCustomElement as d };